export default "__VITE_ASSET__NkgtmFRqL3gL3KvqfzInvQ__"